import {isInstanceOf} from 'rlink-type-utils';

export default function mapShape (shapeCheckersMap, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    let value = obj[key];
    if (!isInstanceOf(value, Map)) {
      return new TypeError(`Value at ${fullName} is not a map.`);
    }

    for (let [mapKey, valueChecker] of shapeCheckersMap.entries()) {
      let check = valueChecker(value, mapKey, cname, location, `${fullName}<${mapKey}>`);
      if (check) {
        return check;
      }
    }
  };
  checker.getCheckerForKey = key => shapeCheckersMap.get(key);
  checker.makeNew = () => new Map();
  checker.checkerName = 'mapShape';
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!(shapeCheckersMap instanceof Map)) {
    throw new Error(`Invalid argument type to ${checker.checkerName}: ${shapeCheckersMap}`);
  }
  for (let [key, keyChecker] of shapeCheckersMap.entries()) {
    if (typeof keyChecker !== 'function') {
      throw new Error(`Invalid checker at ${key} for ${checker.checkerName}: ${keyChecker}`);
    }
    if (!checker.checkerName) {
      throw new Error(`Non-rlink-shape checker at ${key} for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
    }
  }
  return checker;
}



// WEBPACK FOOTER //
// ./lib/rlink-shapes/mapShape.js